import React ,{useState,useRef,useEffect} from 'react';
import Modal from 'react-modal';
import { AlertTriangle, Truck, Clock, Route,X,Trash2,ArrowUpDown,Package, PackageCheck  } from 'lucide-react';
import { convertMinutesToHHMM } from '../../utils/formatters';
import { simulateDeleteWaypoint,simulateReorderWaypoints,simulateCleanWaypoint,optimizeSimulation } from '../../api/commande';
import ReorderModal from './SimulateReorderWaypoint';
import ActionModal from '../ValidationModal/ActionModal'
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import {isSimulationVisibleAtom} from "../../utils/price"
import { useAtom } from 'jotai';


const styles = {
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: 0,
    borderRadius: '10px',
    border: 'none',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
    fontFamily: 'Montserrat, sans-serif',
    maxHeight: '80vh',
    overflow: 'hidden',
    width: '80%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #5BBCEA 0%, #2196F3 100%)',
    padding: '24px 32px',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  },
  closeButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    cursor: 'pointer',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.2s ease',
  },
  content: {
    padding: '20px',
    maxHeight: 'calc(80vh - 70px)',
    overflowY: 'auto',
    paddingBottom: '80px',

  },
 waypoint: {
    background: '#ffffff',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    position: 'relative',
    transition: 'all 0.2s ease',
    ':hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    }
  },
  waypointHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px'
  },
  address: {
    fontSize: '16px',
    fontWeight: '500'
  },
  warning: {
    background: '#FEF3C7',
    color: '#D97706',
    padding: '10px',
    borderRadius: '6px',
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '500'
  },
 
  constraintsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '1rem',
    marginBottom: '1.5rem'
  },
  constraintCard: {
    background: '#FFFFFF',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    marginBottom: '12px',
    border: '1px solid #E5E7EB'
  },
  constraintLabel: {
    fontSize: '14px',
    color: '#6B7280',
    display: 'block',
    marginBottom: '4px'
  },
  constraintValue: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#1F2937'
  },
  constraintColumn: {
    background: '#F8FAFC',
    borderRadius: '8px',
    padding: '16px',
    border: '1px solid #E5E7EB'
  },
  columnTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#1F2937',
    margin: '0 0 16px 0',
    paddingBottom: '8px',
    borderBottom: '2px solid #E5E7EB'
  },
  deleteButton: {
    background: 'transparent',
    border: 'none',
    color: '#EF4444',
    cursor: 'pointer',
    padding: '4px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    transition: 'background-color 0.2s',
    ':hover': {
      background: '#FEE2E2'
    }
  },
  actionButton: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    transition: 'background-color 0.2s',
  },
  depot : {
    backgroundColor: '#F3F4F6',
    opacity: 0.8,
    cursor: 'not-allowed',
  },
 

  warningBox: {
    background: '#FFEBEE',
    border: '1px solid #fecaca',
    color: '#F44336',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  constraintsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '24px',
    marginBottom: '32px'
  },
  constraintSection: {
    background: '#ffffff',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
  },
  constraintTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#111827',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  constraintItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0',
    borderBottom: '1px solid #f3f4f6'
  },
  waypoint: {
    background: '#ffffff',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    position: 'relative'
  },
  statusBadge: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '500'
  },
  warningBox: {
    background: '#FFEBEE',
    border: '1px solid #fecaca',
    color: '#F44336',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  }
};
const optimizationStyle = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '16px'
  },
  cardsRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr', // Deux colonnes égales
    gap: '20px', // Espace entre les cartes
  },
  card: {
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    padding: '20px',
    background: '#FFFFFF',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    height: '100%', // Pour égaliser la hauteur
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  cardHeader: {
    marginBottom: '16px'
  },
  title: {
    margin: 0,
    color: '#111827',
    fontSize: '18px',
    fontWeight: '600',
    textAlign: 'center'
  },
  metricsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: '24px'
  },
  metricItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px'
  },
  metricLabel: {
    color: '#6B7280',
    fontSize: '14px',
    fontWeight: '500'
  },
  metricValue: {
    color: '#1F2937',
    fontSize: '16px',
    fontWeight: '600'
  },
  chooseButton: {
    background: '#51C7F2',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    width: '100%',
    transition: 'all 0.2s',
    ':hover': {
      background: '#2563EB'
    }
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '24px',
    paddingTop: '16px',
    borderTop: '1px solid #E5E7EB'
  },
  warningText: {
    color: '#6B7280',
    fontSize: '14px',
    flex: 1,
    marginRight: '20px'
  },
  cancelButton: {
    background: 'red',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s',
    ':hover': {
      background: '#F3F4F6'
    }
  }
};

const SimulateWaypoints = ({ isOpen,
   onClose, 
   simulation,
   setSimulation,  
   onSimulationComplete}) => {
  const simulationRef = useRef(simulation);
  const token = useSelector((state) => state.auth.token)
  const [, setIsSimulationVisible] = useAtom(isSimulationVisibleAtom);

  const [loading, setLoading] = useState(false);
  const [showReorderModal, setShowReorderModal] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [showForceCreateModal, setShowForceCreateModal] = useState(false);
  const [showOptimizationModal, setShowOptimizationModal] = useState(false);
  const [showOptimizationConfirmation, setShowOptimizationConfirmation] = useState(false);
  const [selectedOptimizationType, setSelectedOptimizationType] = useState(null);

  const [optimizationChoices, setOptimizationChoices] = useState({
    distance: null,
    duration: null
  });

  const [deleteConfirmation, setDeleteConfirmation] = useState({
    isOpen: false,
    waypointId: null,
    position: null,
    address: null
  });

  useEffect(() => {
    simulationRef.current = simulation;
  }, [simulation]);
  console.log("simulation",simulation)

  useEffect(() => {
    setIsSimulationVisible(isOpen);
    return () => {
      setIsSimulationVisible(false);
    };
  }, [isOpen, setIsSimulationVisible]);


  const handleDeleteConfirm = async () => {
    const { waypointId, position } = deleteConfirmation;
    
    try {
      setLoading(true);
      const currentSimulation = simulationRef.current;
      const data = await simulateDeleteWaypoint({
        waypoints: currentSimulation.waypoints,
        currentPosition: position,
        waypointId,
        taux_chargement: currentSimulation.constraints.loadingTime,
        total_kilometrage: currentSimulation.constraints.mission.maxDistance,
        total_horaire: currentSimulation.constraints.mission.maxDuration
      },token);
      
      if (data.status) {
        toast.success(data.message, {
          style: {
              fontFamily: 'Montserrat',
              },
      })
        setSimulation(data);
        onSimulationComplete(data); 
        setDeleteConfirmation({ isOpen: false, waypointId: null, position: null, address: null });
       
      }
    } catch (error) {
      toast.error(error.response?.data?.error ||  error.response?.data?.message|| "Une erreur s'est produite", {
        style: { fontFamily: 'Montserrat' },
    });
    } finally {
      setLoading(false);
    }
  };


  const handleReorder = async (currentPosition,waypointId, newPosition) => {
    if (!simulation) return;
    
    try {
      setLoading(true);
      const currentSimulation = simulationRef.current;
      const data=await simulateReorderWaypoints({
        waypoints: currentSimulation.waypoints,
        currentPosition,
        waypointId,
        newPosition,
        taux_chargement: currentSimulation.constraints.loadingTime,
        total_kilometrage: currentSimulation.constraints.mission.maxDistance,
        total_horaire: currentSimulation.constraints.mission.maxDuration
      },token)
      
      if (data.status) {
        setSimulation(data);
        onSimulationComplete(data); 
        setShowReorderModal(false);
        toast.success(data.message, {
          style: {
              fontFamily: 'Montserrat',
              },
      })
      }
    } catch (error) {
      toast.error(error.response?.data?.error ||  error.response?.data?.message|| "Une erreur s'est produite", {
        style: { fontFamily: 'Montserrat' },
    });
    } finally {
      setLoading(false);
    }
  };

  const handleForceCreate = async () => {
    try {
      const currentSimulation = simulationRef.current;
      setLoading(true);
      const data = await simulateCleanWaypoint({
        waypoints: currentSimulation.waypoints,
        total_kilometrage: currentSimulation.constraints.mission.maxDistance,
        total_horaire: currentSimulation.constraints.mission.maxDuration,
        taux_chargement: currentSimulation.constraints.loadingTime,

      },token);

      
      if (data.status) {
        toast.success(data.message, {
          style: {
              fontFamily: 'Montserrat',
              },
      })
        setSimulation(data);
        onSimulationComplete(data)
        setShowForceCreateModal(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.error ||  error.response?.data?.message|| "Une erreur s'est produite", {
        style: { fontFamily: 'Montserrat' },
    });
    } finally {
      setLoading(false);
    }
  };
  
  const handleModalClose = () => {
    if (absoluteExceeded) {
      setShowForceCreateModal(true);
    } else {
      onClose();
    }
  };

  const handleOptimize = async () => {
  try {
    setLoading(true);
    const currentSimulation = simulationRef.current;
    const response = await optimizeSimulation({
      waypoints: currentSimulation.waypoints,
      taux_chargement: currentSimulation.constraints.loadingTime,
      total_kilometrage: currentSimulation.constraints.mission.maxDistance,
      total_horaire: currentSimulation.constraints.mission.maxDuration
    }, token);
     

    if (response.status) {
      setOptimizationChoices({
        distance: response.optimizations.distance,
        duration: response.optimizations.duration
      });
      setShowOptimizationConfirmation(false);
       setShowOptimizationModal(true);
    }
  } catch (error) {
    toast.error(error.response?.data?.error || error.response?.data?.message || "Une erreur s'est produite", {
      style: { fontFamily: 'Montserrat' },
    });
  } finally {
    setLoading(false);
  }
  };

  if (!simulation) return null;
  const absoluteExceeded = simulation.constraints.absolu.exceededDuration || 
  simulation.constraints.absolu.exceededDistance;

  
  const applyOptimization = (type) => {
    const newData = optimizationChoices[type];
    setSimulation(newData);
    onSimulationComplete(newData); 
    setShowOptimizationModal(false);
  };



  
  return (
    <>
    <Modal
      isOpen={isOpen}
      onRequestClose={handleModalClose}
      style={{ content: styles.modalContent }}
      ariaHideApp={false}
    >
      <div style={styles.header}>
        <h3 style={{ margin: 0 ,color: 'white',textAlign: 'center'}}>Simulation des Points de Passage</h3>
        <button 
         onClick={handleModalClose}
        style={styles.closeButton}
        >
          <X size={24} />
        </button>
      </div>

      <div style={styles.content}>


      {absoluteExceeded && (
            <div style={styles.warningBox}>
              <AlertTriangle size={24} />
              <div>
                <h3 style={{ margin: 0 }}>Contraintes critiques dépassées</h3>
                <p style={{ margin: '4px 0 0' }}>
                  La mission ne peut pas être créée car les limites {absoluteExceeded && 'absolues'}  sont dépassées.
                </p>
              </div>
            </div>
          )}

         {/* Contraintes Absolues */}
<div style={styles.constraintSection}>
  <div style={styles.constraintTitle}>
    <Route size={20} color="#51C7F2" />
    Contraintes
  </div>
  
  {/* Nouveau message d'information */}
  <div style={{ 
    background: '#F3F4F6',
    borderRadius: '8px',
    padding: '12px',
    marginBottom: '16px',
    fontSize: '14px',
    color: '#4B5563'
  }}>
    <div style={{ marginTop: '8px' }}>
      • Distance maximale : 400 km<br/>
      • Durée maximale : 12h00
    </div>
  </div>

   {/* Affichage des valeurs réelles */}
   <div style={{
     display: 'grid',
     gridTemplateColumns: '1fr 1fr',
     gap: '16px'
   }}>
   <div>
   <div style={styles.constraintItem}>
    <span>Forfait KM choisi</span>
    <strong>{simulation.constraints.mission.maxDistance} km</strong>
  </div>
  <div style={styles.constraintItem}>
    <span>Forfait horaire</span>
    <strong>{convertMinutesToHHMM(simulation.constraints.mission.maxDuration)}</strong>
  </div>
  </div>
  <div>
   <div style={styles.constraintItem}>
    <span>Distance points de passage </span>
    <strong style={{
     color: simulation.constraints.absolu.exceededDistance ? '#F44336' : '#059669'
    }}>
      {((simulation.totalDistance || 0) + (simulation.returnToDepot.distance|| 0)).toFixed(2)} km

    </strong>
  </div>
  <div style={styles.constraintItem}>
    <span>Durée points de passage</span>
    <strong style={{ 
      color: simulation.constraints.absolu.exceededDuration ? '#F44336' : '#059669' 
      }}>
      {convertMinutesToHHMM(simulation.totalDuration + simulation.returnToDepot.duration)}
    </strong>
  </div>
  </div>
  </div>
</div>

   

        {simulation.waypoints.map((waypoint, index) => (
            <div 
              key={index} 
              style={{
              ...styles.waypoint,
              ...(waypoint.depot && styles.depot),
              position: 'relative'
            }}
            >
              {/* Badge d'état */}
               {(!waypoint.depot && (!waypoint.activeAbsolute || !waypoint.activeMission)) && (
                <div style={{
                  ...styles.statusBadge,
                  background: !waypoint.activeAbsolute ? '#FFEBEE' : '#FFF3E0',
                  color: !waypoint.activeAbsolute ? '#F44336' : '#FF9800'
                }}>
                  <AlertTriangle size={14} />
                  {!waypoint.activeAbsolute ? 'Limite absolue' : 'Limite mission'}
                </div>
              )} 

              {/* En-tête du point */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px',color: waypoint.depot ? '#6B7280' : 'inherit'  }}>
                  {waypoint.depot && (
                    <Truck size={20} color="#6B7280" />
                  ) }
                  <h3 style={{ margin: 0, fontSize: '16px' ,   fontStyle: waypoint.depot ? 'italic' : 'normal' }}>{waypoint.adresse.label}</h3>
                </div>
               
              </div>

              {/* Détails du point */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '16px',
                marginTop: '16px'
              }}>
                
               <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6b7280', fontSize: '14px' }}>
                <span>Distance :</span>
                <span style={{ fontWeight: '600', color: '#1f2937' }}>
               {waypoint.distance.toFixed(2)} km
                </span>
               </div>
               <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6b7280', fontSize: '14px' }}>
                <span>Durée :</span>
                <div style={{ padding: '8px 0' }}>
                    {waypoint.depot ? (
                      waypoint.position === 1 ? (
                        // Premier dépôt - Chargement
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                          <Package size={18} color="#51C7F2" />
                          <div>
                            <div style={{ fontSize: '12px', color: '#6B7280' }}>Chargement</div>
                            <div style={{ fontWeight: '600' }}>
                              {convertMinutesToHHMM(waypoint.dureeChargement)}
                            </div>
                          </div>
                        </div>
                      ) : (
                        // Dernier dépôt - Déchargement
                        <div style={{ display: 'grid', gap: '12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Truck size={16} color="#51C7F2" />
                          <div>
                            <div style={{ fontSize: '12px', color: '#6B7280' }}>Conduite</div>
                            <div style={{ fontWeight: '600' }}>
                              {convertMinutesToHHMM(waypoint.dureeConduite)}
                            </div>
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <PackageCheck size={18} color="#51C7F2" />
                        <div>
                            <div style={{ fontSize: '12px', color: '#6B7280' }}>Chargement</div>
                            <div style={{ fontWeight: '600' }}>
                              {convertMinutesToHHMM(waypoint.dureeChargement)}
                            </div>
                          </div>
                        </div>
                      </div>
                
                      )
                    ) : (
                      // Points intermédiaires
                      <div style={{ display: 'grid', gap: '12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Truck size={16} color="#51C7F2" />
                          <div>
                            <div style={{ fontSize: '12px', color: '#6B7280' }}>Conduite</div>
                            <div style={{ fontWeight: '600' }}>
                              {convertMinutesToHHMM(waypoint.dureeConduite)}
                            </div>
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Clock size={16} color="#51C7F2" />
                          <div>
                            <div style={{ fontSize: '12px', color: '#6B7280' }}>Chargement</div>
                            <div style={{ fontWeight: '600' }}>
                              {convertMinutesToHHMM(waypoint.dureeChargement)}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
               </div>
               <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6b7280', fontSize: '14px' }}>
                <span>Position :</span>
                <span style={{ fontWeight: '600', color: '#1f2937' }}>
                {waypoint.position} 
                </span>
               </div>
              
              
              </div>

              {/* Actions */}
              {!waypoint.depot && (
                <div style={{
                  display: 'flex',
                  gap: '8px',
                  marginTop: '16px',
                  justifyContent: 'flex-end'
                }}>
                  <button
                    onClick={() => {
                      setSelectedPosition(waypoint.position);
                      setSelectedPlace(waypoint.adresse.value.place_id)
                      setShowReorderModal(true);
                    }}
                    style={{
                      padding: '8px 12px',
                      background: '#E1F5FE',
                      color: '#51C7F2',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <ArrowUpDown size={16} />
                    Réorganiser
                  </button>
                  <button
                    onClick={() => setDeleteConfirmation({
                      isOpen: true,
                      waypointId: waypoint.adresse.value.place_id,
                      position: waypoint.position,
                      address: waypoint.adresse.label
                    })}
                    style={{
                      padding: '8px 12px',
                      background: '#FFEBEE',
                      color: '#F44336',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <Trash2 size={16} />
                    Supprimer
                  </button>
                </div>
              )}
            </div>
          ))}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          padding: '16px',
          borderTop: '1px solid #e5e7eb'
        }}>
     
       <button
         onClick={handleOptimize}
         disabled={loading}
         style={{
           padding: '8px 16px',
           background: '#51C7F2',
           color: 'white',
           border: 'none',
           borderRadius: '6px',
           marginRight: '12px',
           cursor: loading ? 'not-allowed' : 'pointer',
           opacity: loading ? 0.7 : 1,
           display: 'flex',
           alignItems: 'center',
           gap: '6px'
         }}
        >
            {loading ? (
              "Optimisation ...."
            ) : (
              'Optimiser'
            )}
          
      </button>


          <button
            onClick={() => {
              if (absoluteExceeded) {
                setShowForceCreateModal(true);
              } else {
                onClose();
              }
            }}
            style={{
              padding: '10px 20px',
              background: '#51C7F2',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            {absoluteExceeded ? 'Créer quand même' : 'Fermer'}
          </button>
        </div>
         
         
      </div>
    </Modal>
    <Modal
     isOpen={showOptimizationModal}
     style={{ content: styles.modalContent }}
     ariaHideApp={false}
     onRequestClose={() => setShowOptimizationModal(false)}
    >

  <div style={styles.header}>
    <div style={{ textAlign: 'center', width: '100%' }}>
      <h3 style={{ margin: 0, color: 'white' }}>Choisir le type d'optimisation</h3>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        gap: '20px',
        marginTop: '10px',
        fontSize: '14px',
        color: 'rgba(255, 255, 255, 0.9)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Truck size={16} />
          <span>
            Distance actuelle: {((simulation?.totalDistance || 0) + (simulation?.returnToDepot?.distance || 0)).toFixed(2)} km
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Clock size={16} />
          <span>
            Durée actuelle: {convertMinutesToHHMM((simulation?.totalDuration || 0) + (simulation?.returnToDepot?.duration || 0))}
          </span>
        </div>
      </div>
    </div>
  </div>
   <div style={optimizationStyle.container}>
   {optimizationChoices?.distance && optimizationChoices?.duration && (
    <div style={optimizationStyle.cardsRow}>
      {/* Carte Temps */}
      <div style={optimizationStyle.card}>
        <div style={optimizationStyle.cardHeader}>
          <h4 style={optimizationStyle.title}>Optimisation en Temps</h4>
        </div>
        <div style={optimizationStyle.metricsContainer}>
          <div style={optimizationStyle.metricItem}>
            <span style={optimizationStyle.metricLabel}>Durée</span>
            <span style={optimizationStyle.metricValue}>
            {convertMinutesToHHMM(optimizationChoices?.duration?.totalDuration+optimizationChoices?.duration?.returnToDepot.duration)}

            </span>
          </div>
          <div style={optimizationStyle.metricItem}>
            <span style={optimizationStyle.metricLabel}>Distance</span>
            <span style={optimizationStyle.metricValue}>
            {((optimizationChoices?.duration?.totalDistance || 0) + (optimizationChoices?.duration?.returnToDepot?.distance || 0)).toFixed(2)} km

            </span>
          </div>
        </div>
        <button 
          style={optimizationStyle.chooseButton}
          onClick={() =>{
            setSelectedOptimizationType('duration');
            setShowOptimizationConfirmation(true)
          }}
        >
          Choisir
        </button>
      </div>

      {/* Carte Distance */}
      <div style={optimizationStyle.card}>
        <div style={optimizationStyle.cardHeader}>
          <h4 style={optimizationStyle.title}>Optimisation en Distance</h4>
        </div>
        <div style={optimizationStyle.metricsContainer}>
          <div style={optimizationStyle.metricItem}>
            <span style={optimizationStyle.metricLabel}>Durée</span>
            <span style={optimizationStyle.metricValue}>
            {convertMinutesToHHMM(optimizationChoices?.distance?.totalDuration+optimizationChoices?.distance?.returnToDepot.duration)}
            </span>
          </div>
          <div style={optimizationStyle.metricItem}>
            <span style={optimizationStyle.metricLabel}>Distance</span>
            <span style={optimizationStyle.metricValue}>
            {((optimizationChoices?.distance?.totalDistance || 0) + (optimizationChoices?.distance?.returnToDepot?.distance || 0)).toFixed(2)} km
            </span>
          </div>
        </div>
        <button 
          style={optimizationStyle.chooseButton}
          onClick={() =>{
            setSelectedOptimizationType('distance');
            setShowOptimizationConfirmation(true)
          }}
        >
          Choisir
        </button>
      </div>
    </div>
   )}

    {/* Footer */}
    <div style={optimizationStyle.footer}>
      <span style={optimizationStyle.warningText}>
        Si vous appliquez cette optimisation, l'ordre des points de passage sera mis à jour
      </span>
      <button
        style={optimizationStyle.cancelButton}
        onClick={() => setShowOptimizationModal(false)}
      >
        Annuler
      </button>
    </div>
  </div>
   </Modal>
    <ReorderModal
        isOpen={showReorderModal}
        onClose={() => {
          setShowReorderModal(false);
          setSelectedPlace(null);
          setSelectedPosition(null);
        }}
        
        onReorder={handleReorder}
        waypoints={simulation?.waypoints || [] }
        currentPosition={selectedPosition}
        placeId={selectedPlace}
      /> 

     <ActionModal
         isOpen={deleteConfirmation.isOpen}
         onRequestClose={() =>{}}
         title="Supprimer un point de passage"
         message={`Êtes-vous sûr de vouloir supprimer le point de passage situé à ${deleteConfirmation.address} ?`}
         onConfirm={handleDeleteConfirm} 
         onCancel={() => setDeleteConfirmation({ isOpen: false, waypointId: null, position: null, address: null })}
         isLoading={loading}
      />
        {/* Ajoutez cette nouvelle modal de confirmation */}
        <ActionModal
        isOpen={showForceCreateModal}
        onRequestClose={() => setShowForceCreateModal(false)}
        title="Création avec dépassement"
        message={
          <>
            <p>Vous êtes sur le point de créer une mission qui dépasse les limites absolues :</p>
            <ul style={{ margin: '10px 0', paddingLeft: '20px' }}>
              {simulation.constraints.absolu.exceededDistance && (
                <li>Distance totale: {(simulation.totalDistance + simulation.returnToDepot.distance).toFixed(2)} km (limite: 400 km)</li>
              )}
              {simulation.constraints.absolu.exceededDuration && (
                <li>Durée totale: {convertMinutesToHHMM(simulation.totalDuration + simulation.returnToDepot.duration)} (limite: 12h00)</li>
              )}
            </ul>
            {simulation.waypoints.some(wp => !wp.activeAbsolute) && (
            <p style={{ color: '#F44336', fontWeight: 500 }}>
             À partir de la position {simulation.waypoints.find(wp => !wp.activeAbsolute)?.position}, 
             les points de passage suivants seront supprimés si vous continuez.
           </p>
             )}

            <p>Souhaitez-vous quand même créer cette mission ?</p>
          </>
        }
        onConfirm={handleForceCreate}
        onCancel={() =>{
          setShowForceCreateModal(false)
          onClose();
        } }
        isLoading={loading}
        confirmText="Créer quand même"
        cancelText="Annuler"
      />
     
     <ActionModal
       isOpen={showOptimizationConfirmation}
       onRequestClose={() => {
        setShowOptimizationConfirmation(false);
        setSelectedOptimizationType(null);
      }}
    
       title="Confirmation d'optimisation"
       message={`Êtes-vous sûr de vouloir appliquer l'optimisation ${
        selectedOptimizationType === 'distance' 
          ? 'en distance' 
          : 'en temps'
      } ? Cette action modifiera définitivement l'ordre des points de passage.`}
      onConfirm={() => {
        applyOptimization(selectedOptimizationType);
        setShowOptimizationConfirmation(false);
        setSelectedOptimizationType(null);
      }}
      onCancel={() => {
        setShowOptimizationConfirmation(false);
        setSelectedOptimizationType(null);
      }}
       isLoading={loading}
       confirmText="Confirmer l'optimisation"
       cancelText="Annuler"
      />
    </>
  );
};

export default SimulateWaypoints;